import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Bridge } from './components/Bridge';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Pricing } from './components/Pricing';
import { PricingCountdown } from './components/PricingCountdown';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen font-sans text-gray-800 selection:bg-sage-200 selection:text-sage-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBanner data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <PainPoints data-id="element-6" />
        <Bridge data-id="element-7" />
        <Features data-id="element-8" />
        <Benefits data-id="element-9" />
        <Pricing data-id="element-10" />
        <PricingCountdown data-id="element-11" />
        <Testimonials data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
    </div>;
}